import React from 'react';
import './Alert.css';

const Alert = ({ type = 'info', message, onClose, onConfirm, onCancel, confirmText = 'OK', cancelText = 'Cancel' }) => {
  const isConfirm = onConfirm && onCancel;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'confirm':
        return '?';
      default:
        return 'ℹ';
    }
  };

  const getTitle = () => {
    switch (type) {
      case 'success':
        return 'Success';
      case 'error':
        return 'Error';
      case 'warning':
        return 'Warning';
      case 'confirm':
        return 'Confirm';
      default:
        return 'Information';
    }
  };

  return (
    <div className="alert-overlay" onClick={isConfirm ? undefined : onClose}>
      <div className={`alert-box alert-${type}`} onClick={(e) => e.stopPropagation()}>
        <div className="alert-header">
          <div className={`alert-icon alert-icon-${type}`}>
            {getIcon()}
          </div>
          <h3 className="alert-title">{getTitle()}</h3>
        </div>
        <div className="alert-body">
          <p>{message}</p>
        </div>
        <div className="alert-footer">
          {isConfirm ? (
            <>
              <button className="alert-btn alert-btn-cancel" onClick={onCancel}>
                {cancelText}
              </button>
              <button className="alert-btn alert-btn-confirm" onClick={onConfirm}>
                {confirmText}
              </button>
            </>
          ) : (
            <button className="alert-btn alert-btn-ok" onClick={onClose}>
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Alert;
